import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "reactstrap";

import { useTranslation } from "react-i18next";
import { GetLanguageString } from "../../../helper/Components";
import { GetCustomStyles } from "../../../helper/Method";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { IoArrowBackSharp } from "react-icons/io5";
import swal from "sweetalert";
import AmanatToCashAccountForm from "./AmanatToCashAccountForm";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import { ApiFinance } from "../../ApiFinance";
import { LoadingSpinner } from "../../../../constants/const";
import AddNewBankAccount from "./AddNewBankAccount";
import { addMember } from "../../../member/ApiMember";
const TransferAmanatToCashInHand = ({ history }) => {
  const { t } = useTranslation();

  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));

  const [fundAccountBalances, setFundAccountBalances] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unitBankAccounts, setUnitBankAccounts] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [refreshBankList, setRefreshBankList] = useState(false);
  const [handleAddNew, setHandleAddNew] = useState(false);
  // -- FORM DATA --
  const [values, setValues] = useState({
    transferAmount: null,
    memo: "",
    requestDate: new Date(),
    unitId: loggedInUnitId,
    rafiqBankId: null,
  });

  const [errors, setErrors] = useState({});
  const showRowsTable =
    values.transferAmount > (parseInt(fundAccountBalances.cashLimit) || 0);
  const showExtraFile =
    values.transferAmount > (parseInt(fundAccountBalances.expenseLimit) || 0);

  // FETCH BALANCE
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetCashToAmanatTransferData(loggedInUnitId)
      .then((res) => setFundAccountBalances(res.data))
      .catch((err) => {
        console.error("Error fetching fund account balances:", err);
        swal({
          title: t("network_requet_error"),
          icon: "error",
          buttons: "OK",
        });
        history.goBack();
      })
      .finally(() => {
        setLoading(false);
      });
  }, [loggedInUnitId, history, t]);
  useEffect(() => {
    addMember()
      .GetUnitBankAccounts(loggedInUnitId)

      .then((res) => {
        if (res.data.length > 0) {
          setUnitBankAccounts(res.data);
          if (!refreshBankList) {
            setSelectedBankAccount(res.data[0]);
            setValues((prev) => ({
              ...prev,
              rafiqBankId: res.data[0].value,
            }));
          }
        } else {
          setUnitBankAccounts([]);
          setSelectedBankAccount(null);
        }
      })
      .catch((err) => {
        console.error("Error fetching unit bank accounts:", err);
      })

      .finally(() => {});
  }, [loggedInUnitId, refreshBankList]);

  console.log("SelectedBank", selectedBankAccount);
  // INPUT HANDLER
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    // Enforce numeric-only inputs
    if (name === "transferAmount") {
      newValue = value.replace(/\D/g, "");
      e.target.value = newValue;
    }

    // Always update values first
    setValues((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    // Clear previous error for this field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    // Now apply validation only for transferAmount
    if (name === "transferAmount") {
      const transferAmount = Number(newValue) || 0;
      const amanatBalance =
        Number(fundAccountBalances.amanatAccountBalance) || 0;

      if (transferAmount > amanatBalance) {
        setErrors((prev) => ({
          ...prev,
          transferAmount: t(
            "transfer_amount_greater_than_cash_account_balance"
          ),
        }));

        setValues((prev) => ({
          ...prev,
          file: null,
        }));
      }
    }
  };

  // DATE HANDLER
  const handleDateChange = (date) => {
    setValues({
      ...values,
      requestDate: date,
    });
    setErrors((prev) => ({ ...prev, requestDate: "" }));
  };
  const [rows, setRows] = useState([
    {
      description: "",
      amount: "",
      date: new Date(),
      expenseType: "past",
      file: null,
    },
  ]);
  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      rows: rows,
    }));
  }, [rows, setValues]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        description: "",
        amount: "",
        date: new Date(),
        expenseType: "past",
        file: null,
      },
    ]);
  };

  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
  };

  const handleChangeTableData = (index, field, value) => {
    // 1. Update row data
    const updated = [...rows];
    updated[index][field] = value;

    if (field === "expenseType" && value === "future") {
      updated[index].file = null;
    }
    setRows(updated);

    setErrors((prev) => {
      const newErrors = { ...prev };

      // Description changed → remove description error
      if (field === "description") {
        delete newErrors[`row_${index}_description`];
      }

      // Amount changed → remove amount error
      if (field === "amount") {
        delete newErrors[`row_${index}_amount`];
      }

      if (field === "file") {
        delete newErrors[`row_${index}_file`];
      }

      if (field === "expenseType") {
        if (value === "future") {
          delete newErrors[`row_${index}_file`];
        }
      }

      return newErrors;
    });
  };

  // FILE HANDLER

  // VALIDATION
  const validate = () => {
    let temp = {};
    temp.transferAmount = "";

    const transferAmount = Number(values.transferAmount || 0);
    const amanatBalance = Number(fundAccountBalances.amanatAccountBalance || 0);

    if (!values.transferAmount) {
      temp.transferAmount = t("common_field_required_error");
      // 2. Not zero
    }
    if (transferAmount === 0) {
      temp.transferAmount = t("common_field_required_error");
    }
    if (transferAmount > amanatBalance) {
      temp.transferAmount = t(
        "transfer_amount_greater_than_cash_account_balance"
      );
    }
    if (Number(values.transferAmount) < fundAccountBalances.cashLimit) {
      setErrors({});
      return true;
    }
    if (showExtraFile) {
      if (!values.extraFile) {
        temp.extraFile = t("transactions_shura_approval_attachment_required");
      }
    }
    if (Number(values.transferAmount) > fundAccountBalances.cashLimit) {
      values.rows.forEach((row, index) => {
        if (row.expenseType === "past" && !row.file) {
          temp[`row_${index}_file`] = t(
            "transactions_past_expense_file_required"
          );
        }
        if (!row.description) {
          temp[`row_${index}_description`] = t("common_field_required_error");
        }
        if (!row.amount || Number(row.amount) <= 0) {
          temp[`row_${index}_amount`] = t("common_field_required_error");
        }
      });
    }
    temp.bankCharges = values.bankCharges ? "" : "";
    temp.requestDate = values.requestDate
      ? ""
      : t("common_field_required_error");
    temp.referenceNo = values.referenceNo ? "" : "";

    temp.file = values.file ? "" : "";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };
  // SUBMIT HANDLER
  const handleBankAccountChange = (option) => {
    setSelectedBankAccount(option);
    setValues((prev) => ({
      ...prev,
      rafiqBankId: option.value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (values.transferAmount === 0 || values.transferAmount === null) {
      setErrors({ transferAmount: t("common_field_required_error") });
      return;
    }
    // 1️⃣ Validate main form + rows
    if (!validate()) return;

    // Row-level validation: file required for Past rows
    if (Number(values.transferAmount) > fundAccountBalances.cashLimit) {
      const rowErrors = {};
      values.rows.forEach((row, index) => {
        if (row.expenseType === "past" && !row.file) {
          rowErrors[`row_${index}_file`] = "File is required for past expense.";
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        setErrors((prev) => ({ ...prev, ...rowErrors }));
        return; // stop submit
      }
    }

    setLoading(true);

    try {
      // 2️⃣ Prepare FormData
      const formData = new FormData();
      formData.append("transferAmount", values.transferAmount);
      formData.append("memo", values.memo);
      formData.append("requestDate", values.requestDate.toISOString());
      formData.append("unitId", values.unitId);
      formData.append("rafiqBankId", values.rafiqBankId);
      if (showExtraFile && values.extraFile) {
        formData.append("shuraApprovalFile", values.extraFile);
      }

      // Append each
      if (showRowsTable) {
        values.rows.forEach((row, index) => {
          formData.append(`expenses[${index}].description`, row.description);
          formData.append(`expenses[${index}].amount`, row.amount);
          formData.append(`expenses[${index}].date`, row.date.toISOString());
          formData.append(`expenses[${index}].expenseType`, row.expenseType);
          if (row.file) {
            formData.append(`expenses[${index}].file`, row.file);
          }
        });
      }
      // 3️⃣ Call API
      const res = await ApiFinance().TransferAmanatToCashInHand(formData);

      // 4️⃣ Handle response
      if (res.data.statusCode === "200") {
        swal({
          title: t("transactions_request_to_transfer"),
          icon: "success",
          buttons: "OK",
        });
        // Reset state OnLy on success
        setValues({
          transferAmount: null,
          memo: "",
          requestDate: new Date(),
          unitId: values.unitId,
          rafiqBankId: values.rafiqBankId,
          rows: [], // reset table
        });
        history.goBack();
        setErrors({});
      } else {
        swal({
          title: t("transfer_failed"),
          icon: "error",
          buttons: "OK",
        });
      }
    } catch (err) {
      console.error(err);
      swal({
        title: t("transfer_failed"),
        icon: "error",
        buttons: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title">
          <h5>
            {
              <GetLanguageString props="transactions_amanat_to_cash_in_hand_account" />
            }
          </h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>
        {handleAddNew && (
          <AddNewBankAccount
            setModal={setHandleAddNew}
            getAddedBankAccount={setSelectedBankAccount}
            setRefreshBankList={setRefreshBankList}
          />
        )}
        <div className="ibox-content">
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <AmanatToCashAccountForm
                setValues={setValues}
                values={values}
                errors={errors}
                fundAccountBalances={fundAccountBalances}
                handleInputChange={handleInputChange}
                handleDateChange={handleDateChange}
                handleBankAccountChange={handleBankAccountChange}
                selectedBankAccount={selectedBankAccount}
                unitBankAccounts={unitBankAccounts}
                handleAddNew={setHandleAddNew}
                showRowsTable={showRowsTable}
                showExtraFile={showExtraFile}
                handleChangeTableData={handleChangeTableData}
                addRow={addRow}
                removeRow={removeRow}
                rows={rows}
                disableFileForFuture={true}
              />

              {/* Footer */}
              <Row
                style={{
                  backgroundColor: "white",
                  marginLeft: 2,
                  marginRight: 2,
                  height: 50,
                }}
              >
                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    gap: 10,
                    justifyContent: "flex-end",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Button
                    color="white"
                    className={GetCustomStyles().btn_style}
                    onClick={() => history.goBack()}
                  >
                    <GetLanguageString props="common_cancel" />
                  </Button>
                  <Button
                    color="primary"
                    className={GetCustomStyles().btn_style}
                    type="submit"
                  >
                    <GetLanguageString props="transfer" />
                  </Button>
                </div>
              </Row>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(TransferAmanatToCashInHand);
